import { FC } from 'react';
import { Tooltip } from 'react-tooltip';

export type HeadingGroupProps = {
  title: string;
  subtitlePrefix?: string;
  subtitleTooltip?: string;
  subtitlePostfix?: string;
  tooltip?: string;
};

export const HeadingGroup: FC<HeadingGroupProps> = ({
  title,
  subtitlePrefix,
  subtitleTooltip,
  subtitlePostfix,
  tooltip,
}) => (
  <hgroup>
    {tooltip && (
      <Tooltip anchorSelect="#title-tooltip" place="bottom">
        {tooltip}
      </Tooltip>
    )}
    <h1 className="text-sm/6 font-extrabold">{title}</h1>
    <span className="text-3xl font-light leading-[2.125rem]">
      {subtitlePrefix}{' '}
    </span>
    <a id="title-tooltip">
      <span className="cursor-help text-3xl font-light leading-[2.125rem] text-gray-400 underline">
        {subtitleTooltip}
      </span>
    </a>
    <span className="text-3xl font-light leading-[2.125rem]">
      {' '}
      {subtitlePostfix}
    </span>
  </hgroup>
);
